<!-- 登录后的欢迎少侠，更换账号组件 -->
<template>
  <div class="role">
    <div class="p-10" v-if="user?.isLoggedIn">
      <div class="f-row">
        少侠&nbsp;<span class="role_name">{{ user?.userId }}</span>
        <span class="change" v-click="{ btn_name: '更换账号' }" @click="login">&nbsp;更换账号</span>
        <span class="change" v-click="{ btn_name: '退出登录' }" @click="logout">&nbsp;退出登录</span>
      </div>
    </div>
    <div v-else>
      <div>
        欢迎少侠,请先&nbsp;<span class="change" v-click="{ btn_name: '登录' }" @click="login">登录账号</span>
      </div>
    </div>
  </div>
  <nut-popup v-model:visible="dialog.choose" :duration="0.1" three-dimensional position="bottom" :lock-scroll="true"
    :close-on-click-overlay="false" :closeable="false">
    <nut-picker v-model="choose_server" :columns="roles" cancelText=" " title="请选择绑定角色" @confirm="confirm" />
  </nut-popup>
</template>
<script setup>
import { onMounted, reactive, ref, } from 'vue';
import eventEmitter from '@utils/event';
import { tx3_get_roles, init, bind_role } from '@utils/api';
import { bindRoleSuccessLog } from '../utils/log';
const { user, set_user } = inject('GlobalStore');
import useWeChatEnv from "../plugins/vue/useWeChatOrMiniProgram"
const { isWeChat } = useWeChatEnv();
const dialog = reactive({
  choose: false,
});

async function loadBindRole() {
  console.log('拉起登录绑定页面');
  const data = await tx3_get_roles();
  if (data.code == 1) {
    if (data.data.roles.length == 0) {
      eventEmitter.emit('toast', {
        text: '该账号没有角色，请更换角色尝试',
        duration: 2,
      });
      return false;
    } else {
      change_role(data.data.roles);
    }
  } else {
    eventEmitter.emit('toast', {
      text: '拉取角色失败',
    });
  }
}

function genRedirectUrl(authUrl, h5Project, h5Activity, h5Url) {
  const url = new URL(authUrl);
  const params = new URLSearchParams(url.search);
  params.set('project', h5Project);
  params.set('activity', h5Activity);
  params.set('redirect_url', h5Url);
  url.search = params.toString();
  return url.toString();
}

async function initAction() {
  // 做一下初始化的操作
  console.log('init_action')
}

function login() {
  window.h5sdk.showLogin();
}

function logout() {
  window.h5sdk.logout();
  set_user({});
}
onMounted(() => {
  window.h5sdk.core.UserLogin().then((data) => {
    set_user(data.$state);
  })
  window.h5sdk.core.registerEventHandler('onUnisdkLoginAfter', () => {
    window.h5sdk.core.UserLogin().then((data) => {
      console.log('登录成功',data.$state)
    set_user(data.$state);
  })
  })
  eventEmitter.on('init', (callback) => {
    console.log('emit on init');
  });
  eventEmitter.on('login', () => {
    console.log('emit on login');
    login();
  });
});

// 绑定相关
const roles = ref();
const choose_server = ref();
function change_role(data) {
  let res = [];
  data.map((e) => {
    res.push({
      text: `【${e.server_name}】- ${e.role_name}`,
      value: `${e.server_id}|${e.role_id}`,
    });
  });
  roles.value = res;
  dialog.choose = true;
}
async function confirm() {
  let res = [];
  if (choose_server.value == undefined) {
    res = roles.value[0].value.split('|');
  } else {
    res = choose_server.value[0].split('|');
  }

  let data = await bind_role({ server_id: res[0], role_id: res[1] });
  if (data.code == 1) {
    // 绑定成功
    await initAction();
    bindRoleSuccessLog();
    dialog.choose = false;
  } else {
    eventEmitter.emit('toast', {
      text: '绑定失败，请重试！',
      duration: 2,
    });
  }
}

function handle_switch() {
  if (ds.isGodlike) {
    ds.callHandler('openLoginPage').then((res) => {
      console.log(res);
    });
  } else {
    login();
  }
}
</script>
<style scoped lang="scss">
.role {
  color: white;
  font-size: 22px;
  font-weight: bold;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  @include bg('shang2');
  position: relative;
  top: 100px;
  z-index: 100;
}

.role_name {
  color: #fffa69;
}

.change {
  color: #56ff66;
  text-decoration: underline;
}

.current-role {
  color: #a99a7a;
}

.empty {
  width: 50px;
  height: 50px;
}

#h5-sdk-container {
  height: 0px;
  width: 0px;
  display: none;
}
</style>
